/*
 * Given date is included in the given list of dates
 * @return boolean
 */
import moment from 'moment-timezone';

export default function dateIsInDateList({
  date,
  dateList = [],
  timezone = moment.tz.guess(),
}) {
  const dateStart = moment(date).tz(timezone).startOf('day');
  const dateListStart = dateList?.map((date) =>
    moment(date).tz(timezone).startOf('day')
  );

  return dateListStart.some((date) => date.isSame(dateStart));
}
